/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useState} from 'react';
import {ReportsFilter} from '@ion/query/src/hooks/useAssetHistory';
import {FilterItems, TrackingFilters} from '../types/types';

export interface FilterState {
  [key: string]: FilterItems;
};

// allows for overriding the filter state values with other types (intended for editing filters,
// such that the current state of the filter should be included in the filter state)
export interface ExtendedFilterItems extends FilterItems {
  open?: boolean;
};

export interface AugmentedFilterState {
  [key: string]: ExtendedFilterItems;
};

/**
 * @useFilterState
 *
 * Simple hook for managing the state of filters, which
 * includes am optional argument for clearing the filters.
 * This hook is specific to an object that has loading, items,
 * selected, and error properties for each root property.
 */
export const useFilterState = (
  initialState: FilterState | {} = {}
): [ {} | ReportsFilter | TrackingFilters, (val: FilterState, clear?: boolean) => void] => {
  const [filterValues, setFilterValues] = useState(initialState);

  const setFilterState = (val: FilterState, clear?: boolean) => {
    setFilterValues(clear ? {...val} : {...filterValues, ...val});
  };
  return [filterValues, setFilterState];
};

export default useFilterState;
